export default __webpack_public_path__ + "static/media/bike-icon.f9bd478a.svg";